import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

import Ico1 from "../../../assets/images/sezione-05-popup-03-04-ico-01.svg";
import Ico2 from "../../../assets/images/sezione-05-popup-03-04-ico-02.svg";
import Ico3 from "../../../assets/images/sezione-05-popup-03-04-ico-03.svg";

export default function MissionVisionPurpose({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Purpose Vision Mission", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => { if (e.target === overlayRef.current) onClose?.(); }}
      role="dialog"
      aria-modal="true"
      aria-label="Purpose Vision Mission"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("MissionVisionPurpose")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8">
          <h2 className="text-[#A3648F] text-[30px] md:text-[40px] font-normal">
            Mission Vision Purpose
          </h2>

          {/* Colonne */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-0 bg-transparent">
            {/* Purpose */}
            <section className="p-6 md:p-8 flex flex-col items-start">
              <img src={Ico1} alt="" className="w-[60px] h-[60px] mb-3 mx-auto" />
              <h3 className="text-[#0E3761] text-[18px] md:text-[22px] font-semibold mb-4 mx-auto">
                Purpose
              </h3>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-bold uppercase leading-[1.15] mb-3">
                Taking care of people for a better world, together.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-semibold leading-[1.2] mb-4">
                Il Purpose è il faro che guida ogni azione e decisione aziendale.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] leading-[1.2]">
                Reale Group si prende cura del benessere delle Persone che fanno parte del Gruppo, a qualsiasi titolo:
                clienti, dipendenti, intermediari, fornitori, Stakeholder in generale.
              </p>
            </section>


            {/* Vision */}
            <section className="p-6 md:p-8 flex flex-col items-start">
              <img src={Ico2} alt="" className="w-[60px] h-[60px] mb-3 mx-auto" />
              <h3 className="text-[#0E3761] text-[18px] md:text-[22px] font-semibold mb-4 mx-auto">
                Vision
              </h3>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-bold uppercase leading-[1.15] mb-3">
                Developing the wellbeing of people and communities, creating trust over time.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-semibold leading-[1.2] mb-4">
                Nel tempo, abbiamo deciso di investire sulla fiducia.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] leading-[1.2]">
                Per attuare il Purpose, cerchiamo di sviluppare il benessere delle persone e delle comunità nelle quali
                operiamo. Il nostro posizionamento distintivo sul mercato nasce dall’affidabilità e questa deriva dalle
                relazioni durature, trasparenti e credibili con tutti gli Stakeholder.
              </p>
            </section>


            {/* Mission */}
            <section className="p-6 md:p-8 flex flex-col items-start">
              <img src={Ico3} alt="" className="w-[60px] h-[60px] mb-3 mx-auto" />
              <h3 className="text-[#0E3761] text-[18px] md:text-[22px] font-semibold mb-4 mx-auto">
                Mission
              </h3>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-bold uppercase leading-[1.15] mb-3">
                Protecting and helping people with simple and sustainable solutions, inspired by our mutuality principles.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] font-semibold leading-[1.2] mb-4">
                Le coperture assicurative e i servizi che il Gruppo offre danno protezione alle persone.
              </p>

              <p className="text-[#0E3761] text-[16px] md:text-[18px] leading-[1.2]">
                Ci impegniamo a proporre soluzioni sempre più sostenibili e semplici, perché la semplicità è la chiave
                per l’innovazione. Tutto questo, con uno stile unico, dato dall’assoluto rispetto dei nostri princìpi
                mutualistici: una vera peculiarità sul mercato italiano, che si estende a tutte le Società di Reale Group.
              </p>
            </section>
          </div>

          {/* CTA finale */}
          <div className="mt-8">
            <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=70" target="_blank">
              <button
                className="bt-secondary2 text-sm px-4 py-2"
                type="button"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Consulta il Report - cap. 1 • par. 1.3.1.1
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
